class MapReloud {
  constructor() {
    this.selectPlace = document.getElementById("selectPlace");
    this.map = document.getElementById("googleMap");
    this.options = document.querySelectorAll("option");

    this.selectPlace.addEventListener("change", () => this.reloud());
  }

  reloud() {
    let x = selectPlace.value;
    this.map.src = this.options[x - 1].dataset.map;
  }
}

export default MapReloud;
